export default __webpack_public_path__ + "static/media/video.be3e7c0b.mp4";